"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolkadotAuthProvider = void 0;
const caip_1 = require("caip");
const util_1 = require("./util");
const uint8arrays = __importStar(require("uint8arrays"));
const stringHex = (str) => `0x${uint8arrays.toString(uint8arrays.fromString(str), "base16")}`;
const CHAIN_ID = "polkadot:b0a8d493285c2df73290dfb7e61f870f";
class PolkadotAuthProvider {
    constructor(provider, address) {
        this.provider = provider;
        this.address = address;
        this.isAuthProvider = true;
    }
    async authenticate(message) {
        throw new Error(`Not Implemented: PolkadotAuthProvider#authenticate, ${message}`);
    }
    async createLink(did) {
        const { message, timestamp } = util_1.getConsentMessage(did);
        const linkMessageHex = stringHex(message);
        const account = await this.accountId();
        const res = await this.provider.signRaw({
            address: this.address,
            data: linkMessageHex,
            type: "bytes",
        });
        return {
            version: 2,
            type: "eoa",
            message: linkMessageHex,
            signature: res.signature,
            account: account.toString(),
            timestamp: timestamp,
        };
    }
    async accountId() {
        return new caip_1.AccountID({ address: this.address, chainId: CHAIN_ID });
    }
    withAddress(address) {
        return new PolkadotAuthProvider(this.provider, address);
    }
}
exports.PolkadotAuthProvider = PolkadotAuthProvider;
//# sourceMappingURL=polkadot.js.map